export function getProjects(arr) {
  const serverUrl = "http://193.222.62.132:1337"; // путь к серверу

  const projectsAll = arr.map((item, index) => {
    const project = item;
    // console.log(project);
    // debugger;
    return {
      id: project.id,
      title: project.title,
      description: project.description,
      // baner:
      //   serverUrl +
      //   (project.baner.data.attributes.formats.large
      //     ? project.baner.data.attributes.formats.large.url
      //     : project.baner.data.attributes.url),
      baner: serverUrl + project.baner.data.attributes.url,
      banerAlt: project.baner.data.attributes.alternativeText,
      city: project.characteristic.city,
      year: project.characteristic.year,
      stage: project.characteristic.stage,
      projectDescription: project.projectDescription,
      list: project.list,
      // topPhoto:
      //   serverUrl +
      //   (project.detail.topPhoto.data.attributes.formats.large
      //     ? project.detail.topPhoto.data.attributes.formats.large.url
      //     : project.detail.topPhoto.data.attributes.url),
      topPhoto: serverUrl + project.detail.topPhoto.data.attributes.url,
      topPhotoAlt: project.detail.topPhoto.data.attributes.alternativeText,
      // bottomPhoto:
      //   serverUrl +
      //   (project.detail.bottomPhoto.data.attributes.formats.large
      //     ? project.detail.bottomPhoto.data.attributes.formats.large.url
      //     : project.detail.bottomPhoto.data.attributes.url),
      bottomPhoto: serverUrl + project.detail.bottomPhoto.data.attributes.url,
      bottomPhotoAlt:
        project.detail.bottomPhoto.data.attributes.alternativeText,
      otherPhoto: project.otherPhotos.otherPhotos.data,
    };
  });
  return projectsAll;
}
